<mbs-modal
  class="approve-modal"
  [title]="baseModal.data.title || titles[TFAParams.actionType]"
  [isCustomModal]="true"
  [showFooter]="true"
  [titleTextOverflow]="true">
  <ng-container modal-body>
    <mbs-incorrect-time-alert
      *ngIf="isInvalidLocalTime"
      [expiredDate]="TFAParams.timeExpired"></mbs-incorrect-time-alert>

    @if (isReserveAuth) {
      <reserve-auth-confirm
        [reserveAuthSettings]="reserveAuthSettings"
        [authId]="baseModal.data.authId"></reserve-auth-confirm>
    } @else if (isCodeAuth) {
      <ng-container *ngTemplateOutlet="codeAuthTmp"></ng-container>
    } @else {
      <ng-container *ngTemplateOutlet="nonCodeAuthTmp"></ng-container>
    }
  </ng-container>

  <ng-container modalFooter>
    <div class="w-100 d-flex align-items-center justify-content-between">
      <div>
        <mbs-button
          type="primary"
          [size]="MbsSize.md"
          [isCtrl]="true"
          (click)="toggleIsReserveAuth()"
          *ngIf="isCodeAuth && reserveAuthSettings?.enabled">
          {{ (isReserveAuth ? 'Use recovery codes' : 'Use alternative authentication method') | i18next }}
        </mbs-button>
      </div>
      <div class="d-flex gap-2">
        <mbs-button
          type="primary"
          data-dismiss="modal"
          [loading]="isLoading"
          *ngIf="!isCodeAuth && !TFAParams.isGoogleAuth && isTimeExpired"
          (click)="tryAgain()">
          {{ 'shared:tfa.TFADisableModal.tryAgain' | i18next: { format: 'title' } }}
        </mbs-button>

        <mbs-button
          type="primary"
          data-dismiss="modal"
          [loading]="isLoading"
          *ngIf="isCodeAuth && !isReserveAuth"
          (click)="confirmRecoveryCode()">
          {{ 'shared:buttons.confirm' | i18next: { format: 'title' } }}
        </mbs-button>

        <mbs-button
          type="secondary"
          data-dismiss="modal"
          *ngIf="!TFAParams.isRecoveryCodes"
          (click)="baseModal.close()">
          {{ 'shared:tfa.TFADisableModal.close' | i18next: { format: 'title' } }}
        </mbs-button>
      </div>
    </div>
  </ng-container>
</mbs-modal>

<ng-template #codeAuthTmp>
  <mbs-input
    mbsAutoFocus
    (keyup.enter)="confirmRecoveryCode()"
    [imaskOpts]="recoveryCodeMask"
    [unmask]="true"
    [formControl]="recoveryCode"
    [label]="'shared:tfa.TFADisableModal.TFARecoveryCode' | i18next"></mbs-input>
</ng-template>

<ng-template #nonCodeAuthTmp>
  <ng-container *ngIf="isDeclined">
    {{ 'shared:tfa.TFADisableModal.actionDeclined' | i18next }}
  </ng-container>

  <ng-container *ngIf="!isDeclined">
    @if (TFAParams.isGoogleAuth) {
      <ng-container *ngTemplateOutlet="googleAuthTmp"></ng-container>
    } @else {
      <ng-container *ngTemplateOutlet="mspAuthTmp"></ng-container>
    }

    <div
      class="d-flex align-items-center mt-2"
      *ngIf="!TFAParams.isTFADisableAction && !TFAParams.doNotDisturbEnabled">
      <mbs-checkbox
        [(ngModel)]="isNotAskTFA"
        [label]="'shared:tfa.confirmLogin.doNotAskTFA' | i18next"></mbs-checkbox>

      <mbs-select
        [formControl]="selectedPeriod"
        [bindValue]="'value'"
        [bindLabel]="'label'"
        [clearable]="false"
        [items]="periods"
        [id]="'defaultAuthType'"
        [dropdownPosition]="'bottom'"
        appendTo="body"
        [disabledSelf]="!isNotAskTFA"
        [multiple]="false"
        [searchable]="false"
        class="ml-2 period-select"></mbs-select>
    </div>
  </ng-container>

  <mbs-alert
    [type]="alertType.info"
    [icon]="true"
    *ngIf="TFAParams.isRecoveryCodeUsageAvailable && !isDeclined"
    class="mt-3">
    {{ 'shared:tfa.TFADisableModal.' + (TFAParams.isGoogleAuth ? 'casUseRecoveryCodesGoogleAuth' : 'casUseRecoveryCodes') | i18next }}

    <mbs-button
      [isCtrl]="true"
      [loading]="isReserveAuthSettingsLoading"
      (click)="toggleAuthType()"
      class="d-block">
      {{ 'shared:tfa.TFADisableModal.useRecoveryCodes' | i18next }}
    </mbs-button>
  </mbs-alert>
</ng-template>

<ng-template #googleAuthTmp>
  {{ 'shared:tfa.confirmLogin.actionRequiresTFAGoogle' | i18next }}

  <form class="form-row align-items-end mt-2">
    <div class="col-10">
      <mbs-input
        [label]="'shared:tfa.confirmLogin.TFAVerificationCode' | i18next"
        [isErrorsShow]="false"
        [formControl]="googleCode"
        autocomplete="off"
        name="two-fa-code"
        mbsAutoFocus></mbs-input>
    </div>

    <div class="col-2">
      <mbs-button
        [block]="true"
        [loading]="isLoading"
        [disabled]="!googleCode.value"
        (click)="confirmGoogle()"
        buttonType="submit"
        type="primary">
        {{ 'shared:tfa.validate' | i18next: { format: 'title' } }}
      </mbs-button>
    </div>
  </form>

  <mbs-input-errors
    *ngIf="googleCode.invalid && googleCode.touched && googleCode.errors?.tfa"
    [errors]="[googleCode.errors?.tfa]"></mbs-input-errors>
</ng-template>

<ng-template #mspAuthTmp>
  @if (!isTimeExpired) {
    <div>
      <span *ngIf="!isTimeExpired">
        <span>{{ 'shared:tfa.confirmLogin.actionRequiresTFA' | i18next }}</span>
        <mbs-tfa-timer
          class="ml-1"
          *ngIf="!isInvalidLocalTime"
          [expiredDate]="TFAParams.timeExpired"
          (dateExpired)="isTimeExpired = true"></mbs-tfa-timer
        >.
        <span *ngIf="isInvalidLocalTime">limited period of time</span>
        {{ 'shared:tfa.confirmLogin.confirmItByPushOrQr' | i18next }}
      </span>
    </div>

    <div class="d-flex justify-content-center py-3">
      @if (qrCode().loaded) {
        @if (qrCode().qrCodeUrl) {
          <img
            [ngSrc]="qrCode().qrCodeUrl"
            width="140"
            height="140"
            alt="QR code" />
        }
      } @else {
        <span class="loader loader-lg text-primary"></span>
      }
    </div>
  } @else {
    <span *ngIf="isTimeExpired">
      {{ 'shared:tfa.TFADisableModal.requestIsTimeout' | i18next }}
    </span>
  }
</ng-template>
